import { action } from '@ember/object';
import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import setElement from 'bcl/modifiers/set-element';
import { eq } from 'ember-truth-helpers';

interface InputMonthSignature {
  // The arguments accepted by the component
  Args: {
    onChanged: (val: string) => void;
    value: string;
    startYear?: number;
    endYear?: number;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: HTMLDivElement;
}
export default class InputMonthComponent extends Component<InputMonthSignature> {
  get monthNative() {
    const test = document.createElement('input');

    try {
      test.type = 'month';
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      // console.log(e.description);
    }
    return test.type !== 'text';
  }
  @action
  change(event: Event) {
    if (this.args.onChanged) {
      const target = event.target as HTMLSelectElement;
      this.args.onChanged(target.value);
    }
  }
  get startYear() {
    if (this.args.startYear) {
      return this.args.startYear;
    }
    const date = new Date();
    const year = date.getFullYear();
    return year - 10;
  }
  get endYear() {
    if (this.args.endYear) {
      return this.args.endYear;
    }
    const date = new Date();
    const year = date.getFullYear();
    return year + 10;
  }
  get valueYear() {
    const date = new Date();
    const year = date.getFullYear();
    return +(this.args.value?.split('-')?.[0] ?? year);
  }
  get valueMonth() {
    const date = new Date();
    const month = date.getMonth();
    return (this.args.value?.split('-')?.[1] ?? '' + month).padStart(2, '0');
  }
  get years() {
    const valueYear = this.valueYear;
    let start = this.startYear;
    let end = this.endYear;
    if (valueYear < start) {
      start = valueYear;
    }
    if (valueYear > end) {
      end = valueYear;
    }
    const arr = [];
    for (let i = this.startYear; i < end; i++) {
      arr.push(i);
    }
    return arr;
  }
  month = '';
  monthEle?: HTMLSelectElement = undefined;
  @action
  setMonthEle(ele: HTMLSelectElement) {
    this.monthEle = ele;
  }
  year = '';
  yearEle?: HTMLSelectElement = undefined;
  @action
  setYearEle(ele: HTMLSelectElement) {
    this.yearEle = ele;
  }
  @action changedPolyFil() {
    if (this.args.onChanged) {
      this.args.onChanged(this.yearEle?.value + '-' + this.monthEle?.value);
    }
  }

  <template>
    {{#if this.monthNative}}
      <div class="inline" ...attributes>
        <label>
          <input
            type="month"
            class="ml-2 border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
            value={{@value}}
            {{on "change" this.change}}
          />
        </label>

      </div>
    {{else}}
      <div class="inline" ...attributes>

        <label>
          <select
            {{setElement this.setMonthEle}}
            {{on "change" this.changedPolyFil}}
            name="month"
            class="rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
          >
            <option
              value="01"
              selected={{eq "01" this.valueMonth}}
            >Januar</option>
            <option
              value="02"
              selected={{eq "02" this.valueMonth}}
            >Februar</option>
            <option
              value="03"
              selected={{eq "03" this.valueMonth}}
            >März</option>
            <option
              value="04"
              selected={{eq "04" this.valueMonth}}
            >April</option>
            <option value="05" selected={{eq "05" this.valueMonth}}>Mai</option>
            <option
              value="06"
              selected={{eq "06" this.valueMonth}}
            >Juni</option>
            <option
              value="07"
              selected={{eq "07" this.valueMonth}}
            >Juli</option>
            <option
              value="08"
              selected={{eq "08" this.valueMonth}}
            >August</option>
            <option
              value="09"
              selected={{eq "09" this.valueMonth}}
            >September</option>
            <option
              value="10"
              selected={{eq "10" this.valueMonth}}
            >Oktober</option>
            <option
              value="11"
              selected={{eq "11" this.valueMonth}}
            >November</option>
            <option
              value="12"
              selected={{eq "12" this.valueMonth}}
            >Dezember</option>
          </select>
        </label>
        <label>
          <select
            {{setElement this.setYearEle}}
            {{on "change" this.changedPolyFil}}
            name="year"
            class="rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
          >
            {{#each this.years as |year|}}
              <option selected={{eq year this.valueYear}}>{{year}}</option>
            {{/each}}
          </select>
        </label>
      </div>
    {{/if}}
  </template>
}
